export default {
  IcoMoonType: "selection",
  icons: [
    {
      icon: {
        paths: [
          "M809.314 170.016v86.016h-595.97v-86.016h148l44-42.016h211.998l44.004 42.016h147.968zM255.328 809.984v-511.968h511.969v511.968c0 46.015-40.001 86.016-86.016 86.016h-340.002c-46.016 0-86.016-40.001-86.016-86.016h0.064z"
        ],
        attrs: [
          {
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: [
          "delete_remove_trash_icon_177304 2"
        ]
      },
      attrs: [
        {
        }
      ],
      properties: {
        order: 213,
        id: 4,
        name: "trash",
        prevSize: 32,
        code: 59671
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M819.2 771.277c0 28.311-33.226 47.923-61.542 47.923h-245.658v-201.475c0-56.579-56.166-105.725-112.742-105.725h-194.458v-252.675c0-28.262 12.596-54.525 40.909-54.525h266.291v208.125c0 56.525 35.533 99.075 92.058 99.075h215.142v259.277zM921.6 822.525v-307.2c56.579 0 102.4-45.876 102.4-102.401v-307.2c0-56.576-56.164-105.725-112.742-105.725h-307.2c-56.525 0-102.4 45.875-102.4 102.4h-307.2c-56.525 0-92.058 49.149-92.058 105.725v307.201c-56.576 0-102.4 45.821-102.4 102.4v307.2c0 56.525 35.533 99.075 92.058 99.075h307.2c56.576 0 102.4-45.821 102.4-102.4h307.2c56.579 0 112.742-42.55 112.742-99.075z"
        ],
        attrs: [
          {
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: [
          "filled 2"
        ]
      },
      attrs: [
        {
        }
      ],
      properties: {
        order: 214,
        id: 3,
        name: "einteilung",
        prevSize: 32,
        code: 59697
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 1
    },
    {
      icon: {
        paths: [
          "M780.989 20.447c68.349 0 123.764 52.645 123.764 117.576 0 64.952-55.415 117.597-123.764 117.597-68.344 0-123.758-52.645-123.758-117.597 0-64.931 55.415-117.576 123.758-117.576z",
          "M671.981 282.831c25.336 32.343 40.329 72.435 40.329 115.838 0 28.418-6.435 55.404-17.969 79.733-32.024 67.507-103.467 114.488-186.469 114.488s-154.448-46.98-186.47-114.488c-11.535-24.329-17.969-51.316-17.969-79.733 0-44.774 15.967-86.010 42.76-118.864 37.38-45.837 95.892-75.358 161.679-75.358 67.205 0 126.861 30.809 164.108 78.384z",
          "M242.991 20.447c68.347 0 123.761 52.645 123.761 117.576 0 64.952-55.414 117.597-123.761 117.597s-123.761-52.645-123.761-117.597c0-64.931 55.413-117.576 123.761-117.576z",
          "M873.715 879.115v81.78h-731.675v-81.78c0-158.073 134.887-286.219 301.278-286.219h129.12c166.389 0 301.277 128.146 301.277 286.219z",
          "M694.358 478.389c11.533-24.329 17.969-51.316 17.969-79.733 0-43.404-14.999-83.495-40.324-115.838 16.098-8.668 33.442-15.456 51.712-20.097s37.484-7.115 57.306-7.115c122.319 0 221.48 94.208 221.48 210.414v12.369h-308.143z",
          "M321.399 478.389h-299.879v-12.369c0-58.103 24.791-110.707 64.861-148.774 40.091-38.088 95.462-61.64 156.621-61.64 37.251 0 72.371 8.75 103.188 24.186-26.792 32.854-42.76 74.090-42.76 118.864 0 28.418 6.434 55.404 17.969 79.733z",
          "M873.715 981.337h-731.675c-11.885 0-21.52-9.157-21.52-20.448v-81.774c0-169.095 144.805-306.666 322.798-306.666h129.119c177.993 0 322.797 137.572 322.797 306.666v81.774c0 11.291-9.631 20.448-21.52 20.448zM163.56 940.447h688.635v-61.332c0-146.551-125.494-265.777-279.757-265.777h-129.119c-154.259 0-279.758 119.226-279.758 265.777v61.332z",
          "M1002.491 498.828h-308.143c-11.884 0-21.52-9.153-21.52-20.444s9.636-20.444 21.52-20.444h286.445c-4.468-101.020-92.376-181.894-199.788-181.894-17.559 0-34.972 2.161-51.75 6.422-16.309 4.142-32.008 10.243-46.662 18.132-10.332 5.567-23.471 2.118-29.33-7.705-5.864-9.824-2.231-22.299 8.111-27.866 17.828-9.601 36.923-17.022 56.767-22.062 20.405-5.18 41.553-7.808 62.863-7.808 133.993 0 243.006 103.564 243.006 230.859v12.367c0 11.291-9.636 20.444-21.52 20.444z",
          "M780.999 276.061c-80.109 0-145.284-61.926-145.284-138.041 0-76.105 65.175-138.021 145.284-138.021 80.104 0 145.279 61.916 145.279 138.021 0 76.114-65.175 138.041-145.279 138.041zM780.999 40.889c-56.379 0-102.244 43.573-102.244 97.132 0 53.57 45.864 97.152 102.244 97.152 56.374 0 102.238-43.581 102.238-97.152 0-53.558-45.864-97.132-102.238-97.132z",
          "M321.4 498.83h-299.88c-11.885 0-21.52-9.153-21.52-20.444v-12.369c0-61.664 25.273-119.634 71.164-163.23 45.904-43.61 106.93-67.628 171.839-67.628 39.4 0 78.552 9.18 113.225 26.545 10.514 5.267 14.543 17.631 8.999 27.618-5.544 9.989-18.561 13.818-29.071 8.55-28.507-14.278-60.721-21.827-93.153-21.827-53.41 0-103.629 19.764-141.405 55.652-35.751 33.966-56.296 78.533-58.381 126.244h278.183c11.885 0 21.52 9.153 21.52 20.444s-9.634 20.444-21.52 20.444z",
          "M507.873 613.333c-88.733 0-169.628-49.669-206.090-126.534-13.185-27.809-19.869-57.461-19.869-88.132 0-48.034 16.345-93.466 47.269-131.386 43.162-52.925 108.292-83.281 178.69-83.281 71.102 0 138.907 32.384 181.376 86.627 29.168 37.242 44.582 81.516 44.582 128.040 0 30.67-6.683 60.321-19.866 88.128-36.465 76.869-117.361 126.538-206.092 126.538zM507.873 224.889c-56.989 0-109.717 24.58-144.667 67.434-25.025 30.687-38.252 67.461-38.252 106.344 0 24.844 5.408 48.846 16.071 71.337 29.519 62.228 95.010 102.439 166.848 102.439 71.84 0 137.328-40.211 166.851-102.444 10.66-22.489 16.066-46.491 16.066-71.332 0-37.663-12.471-73.5-36.072-103.635-34.902-44.577-88.425-70.143-146.845-70.143z",
          "M242.998 276.061c-80.108 0-145.281-61.926-145.281-138.041 0-76.105 65.173-138.021 145.281-138.021s145.281 61.916 145.281 138.021c0 76.114-65.173 138.041-145.281 138.041zM242.998 40.889c-56.376 0-102.241 43.573-102.241 97.132 0 53.57 45.865 97.152 102.241 97.152s102.241-43.581 102.241-97.152c0-53.558-45.865-97.132-102.241-97.132z"
        ],
        attrs: [
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          },
          {
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: [
          "filled 3"
        ]
      },
      attrs: [
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        },
        {
        }
      ],
      properties: {
        order: 215,
        id: 2,
        name: "sus",
        prevSize: 32,
        code: 59698
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 2
    },
    {
      icon: {
        paths: [
          "M489.954 786.662c4.019 1.34 8.043 2.010 12.062 2.010s8.038-0.337 11.725-2.010c3.349-1.007 319.625-112.909 319.625-455.648 0-182.259-148.757-331.014-331.349-331.014-182.594 0-331.349 148.755-331.349 331.014 0 342.74 316.271 454.641 319.287 455.648zM502.016 151.101c98.5 0 178.573 80.073 178.573 178.573 0 98.166-80.073 178.572-178.573 178.572s-178.574-80.405-178.574-178.572c0-98.5 80.073-178.573 178.574-178.573z",
          "M697.003 731.021c-17.088-11.055-40.205-6.029-51.26 11.055-11.055 17.088-6.033 40.205 11.055 51.264 13.739 8.708 18.091 16.081 18.091 18.423 0 13.402-59.635 52.267-173.21 52.267-113.578 0-172.879-38.865-172.879-52.267 0-2.342 4.355-9.715 18.092-18.423 17.087-11.059 22.112-33.839 11.056-51.264-11.056-17.084-33.838-22.11-51.26-11.055-43.219 27.81-52.265 59.302-52.265 80.742 0.335 82.756 124.633 126.31 247.59 126.31s247.258-43.554 247.258-126.31c0-21.44-9.050-53.269-52.267-80.742z"
        ],
        attrs: [
          {
          },
          {
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: [
          "filled 4"
        ]
      },
      attrs: [
        {
        },
        {
        }
      ],
      properties: {
        order: 216,
        id: 1,
        name: "karte",
        prevSize: 32,
        code: 59700
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 3
    },
    {
      icon: {
        paths: [
          "M873.331 351.565c49.927 0 90.4-39.741 90.4-88.764s-40.472-88.765-90.4-88.765c-49.927 0-90.4 39.741-90.4 88.765s40.472 88.764 90.4 88.764z",
          "M511.122 220.196c49.927 0 90.4-39.741 90.4-88.765s-40.472-88.764-90.4-88.764c-49.926 0-90.4 39.741-90.4 88.764s40.474 88.765 90.4 88.765z",
          "M661.792 440.041v-88.765c0-23.542-9.523-46.119-26.478-62.766s-39.946-25.998-63.922-25.998h-120.536c-23.976 0-46.97 9.352-63.923 25.998s-26.478 39.224-26.478 62.766v88.765h301.336z",
          "M152.228 351.565c49.927 0 90.401-39.741 90.401-88.764s-40.474-88.765-90.401-88.765c-49.927 0-90.401 39.741-90.401 88.765s40.474 88.764 90.401 88.764z",
          "M934.805 395.072h-60.27c-49.898 0-107.271 39.737-107.271 88.764l163.923 224.279h92.813v-224.279c0-23.338-9.357-45.738-26.049-62.351-16.696-16.613-39.38-26.102-63.147-26.413zM315.258 469.19l-96.126 148.384h-69.609l105.468-147.94c0-49.116-40.379-75.449-90.401-75.449h-74.189c-23.976 0-46.969 9.352-63.923 25.998s-26.478 39.224-26.478 62.766v164.214c0 15.696 6.35 30.744 17.652 41.843s26.631 17.335 42.615 17.335h224.857l-1.808 30.832h-159.105l-65.088 116.161h904.008l-256.137-384.143h-391.736z"
        ],
        attrs: [
          {
          },
          {
          },
          {
          },
          {
          },
          {
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: [
          "filled"
        ]
      },
      attrs: [
        {
        },
        {
        },
        {
        },
        {
        },
        {
        }
      ],
      properties: {
        order: 217,
        id: 0,
        name: "klassen",
        prevSize: 32,
        code: 59701
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 4
    },
    {
      icon: {
        paths: [
          "M213.333 170.667h170.667c46.626 0 88.887 18.699 119.689 49.006 4.574 4.5 12.049 4.5 16.623 0 30.801-30.307 73.062-49.006 119.689-49.006h170.667c70.694 0 128 57.308 128 128v426.667c0 70.694-57.306 128-128 128h-129.122c-27.516 0-54.852 4.437-80.956 13.137l-75.098 25.033c-8.755 2.918-18.227 2.918-26.982 0l-75.098-25.033c-26.103-8.7-53.439-13.137-80.954-13.137h-129.123c-70.692 0-128-57.306-128-128v-426.667c0-70.692 57.308-128 128-128zM554.667 791.829l18.935-6.315c34.807-11.601 71.253-17.515 107.942-17.515h129.122c23.565 0 42.667-19.102 42.667-42.667v-426.667c0-23.564-19.102-42.667-42.667-42.667h-170.667c-47.13 0-85.333 38.205-85.333 85.333v450.496z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {
              f: 1
            }
          ]
        },
        tags: [
          "book"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 211,
        id: 0,
        name: "book",
        prevSize: 32,
        code: 59696
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M127.706 386.992l298.666-268.8c48.678-43.811 122.577-43.811 171.255 0l298.667 268.8c26.97 24.274 42.372 58.854 42.372 95.142v326.993c0 70.694-57.306 128-128 128h-597.333c-70.692 0-128-57.306-128-128v-326.993c0-36.288 15.401-70.868 42.373-95.142zM469.333 553.126c-47.128 0-85.333 38.204-85.333 85.333v170.667c0 23.565 19.103 42.667 42.667 42.667h170.667c23.565 0 42.667-19.102 42.667-42.667v-170.667c0-47.13-38.204-85.333-85.333-85.333h-85.333z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {
              f: 0
            }
          ]
        },
        tags: [
          "project"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 207,
        id: 1,
        name: "project",
        prevSize: 32,
        code: 59695
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 1
    },
    {
      icon: {
        paths: [
          "M488.862 740.425c-59.075-23.63-68.921-45.29-68.921-68.92s15.754-45.295 35.446-63.015c35.445-29.54 51.2-76.8 51.2-126.032 0-92.554-57.108-167.385-163.446-167.385s-163.446 74.831-163.446 167.385c0 49.232 15.754 96.492 51.2 126.032 19.692 17.72 35.446 39.385 35.446 63.015s-9.846 45.29-68.923 68.92c-86.646 35.45-169.354 74.835-171.323 149.665 3.938 51.2 43.323 94.52 92.554 94.52h452.923c49.23 0 88.615-43.32 88.615-92.55-1.97-74.835-84.675-116.185-171.325-151.635zM827.572 374.15c0-145.723-120.125-265.846-265.845-265.846v-68.923l-133.909 108.308c-5.908 5.908-3.938 15.754 1.969 21.662l131.94 106.338v-68.923c92.55 0 167.385 74.831 167.385 167.385h-68.925l108.31 133.91c5.905 5.905 15.75 5.905 21.66 0l106.34-133.91h-68.925z"
        ],
        width: 926,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "change-user"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 206,
        id: 2,
        name: "change-user",
        prevSize: 32,
        code: 59678
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 2
    },
    {
      icon: {
        paths: [
          "M914.284 102.4h-91.426v-34.133c0-38.4-32-68.267-73.142-68.267s-73.142 29.867-73.142 68.267v34.133h-329.145v-34.133c0-38.4-32-68.267-73.143-68.267s-73.143 29.867-73.143 68.267v34.133h-91.428c-59.429 0-109.714 46.933-109.714 102.4v34.133c0 19.2 16 34.133 36.571 34.133h950.855c20.577 0 36.574-14.933 36.574-34.133v-34.133c0-55.467-50.284-102.4-109.716-102.4z",
          "M987.426 375.472h-950.855c-20.571 0-36.571 14.933-36.571 34.133v512c0 55.467 50.286 102.4 109.714 102.4h804.57c59.432 0 109.716-46.933 109.716-102.4v-512c0-19.2-15.997-34.133-36.574-34.133zM512 953.606c-150.857 0-272-115.2-272-253.867 0-140.8 123.428-253.867 272-253.867s272.003 115.2 272.003 253.867c0 140.8-121.145 253.867-272.003 253.867z",
          "M539.427 689.067v-108.8c0-8.533-9.143-17.066-18.286-17.066h-18.286c-9.143 0-18.286 8.532-18.286 17.066v119.467c0 6.4 2.286 12.8 9.143 17.067l86.856 81.067c6.861 6.4 18.29 6.4 25.145 0l13.716-12.8c6.855-6.4 6.855-17.067 0-23.467l-80.002-72.533z"
        ],
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "absence"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 120,
        id: 4,
        name: "absence",
        prevSize: 32,
        code: 59673
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 4
    },
    {
      icon: {
        paths: [
          "M772.198 291.984h111.912v-188.535c0-56.69-42.189-103.448-93.611-103.448h-697.321c-51.427 0-93.178 46.759-93.178 103.448v582.142c0 56.69 41.751 103.999 93.178 103.999h246.2c-0.022 0 0.093-0.051 0.093 0.523v69.387h-135.452c-16.455 0-32.421 16.475-32.421 34.617v70.69c0 18.136 15.966 34.52 32.421 34.52 0 0 433.403 2.014 430.149 0-59.682-37.012-70.876-139.827-70.876-139.827h-18.652v-69.387c0-0.438-0.188-0.512-0.284-0.523h-0.055c0 0 0.026 0 0.055 0h35.096v-213.845h-467.541v-452.371h660.286v168.611z",
          "M544.302 789.589c0 0 0.026 0 0.055 0h-0.055z",
          "M770.503 349.555c-76.624 0-138.2 68.137-138.2 152.926v311.883c0 11.548 1.104 22.682 3.271 33.479 17.192 100.301 96.802 176.156 192.444 176.156 94.669 0 173.625-74.052 191.892-172.834 0.028-0.154-0.028-0.455 0-0.603 2.526-11.605 4.090-23.711 4.090-36.198v-311.883c0-84.789-61.577-152.926-138.194-152.926h-28.894v92.298c8.858 7.306 14.717 19.056 14.717 32.275v80.233c0 13.219-5.86 24.966-14.717 32.276v63.943c0 13.346-9.478 24.132-21.538 24.132-12.055 0-21.806-10.786-21.806-24.132v-64.245c-8.738-7.322-14.444-18.86-14.444-31.975v-80.233c0-13.115 5.706-24.656 14.444-31.973v-92.6h-43.065z"
        ],
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "asset"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 121,
        id: 5,
        name: "asset",
        prevSize: 32,
        code: 59674
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 5
    },
    {
      icon: {
        paths: [
          "M139.228 942.791c0 0-0.931 22.892 21.458 22.892 27.86 0 258.115-0.307 258.115-0.307l0.388-211.513c0 0-3.647-34.844 30.15-34.844h107.134c40.008 0 37.562 34.844 37.562 34.844l-0.466 210.853c0 0 218.379 0 252.683 0 28.405 0 27.119-28.484 27.119-28.484v-390.042l-356.127-316.745-378.015 316.785v396.562z",
          "M0 516.736c0 0 32.051 59.135 102.089 0l418.331-353.918 392.18 351.706c81.015 58.437 111.4 0 111.4 0l-503.58-456.163-520.42 458.375z",
          "M903.054 162h-100.847l0.427 122.344 100.42 85.25v-207.594"
        ],
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "house"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 122,
        id: 6,
        name: "house",
        prevSize: 32,
        code: 59675
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 6
    },
    {
      icon: {
        paths: [
          "M991.909 836.915l-178.017-178.011c-19.655-19.644-44.897-30.248-70.61-31.858l-60.467-60.471c89.828-142.82 72.641-334.183-51.593-458.417-144.21-144.213-378.856-144.209-523.065 0-144.21 144.208-144.21 378.854 0.005 523.058 124.233 124.251 315.596 141.437 458.423 51.593l60.456 60.467c1.621 25.714 12.214 50.961 31.863 70.599l178.017 178.022c42.798 42.803 112.179 42.803 154.982 0 42.792-42.786 42.803-112.179 0.006-154.982zM582.588 519.421c-5.194-22.994-13.136-42.221-25.616-47.186l-106.524-42.47-24.945-21.018c-6.585-5.568-16.32-5.159-22.428 0.919l-34.683 34.487-34.776-34.499c-6.118-6.066-15.833-6.459-22.419-0.907l-24.94 21.018-106.53 42.477c-11.95 4.758-19.73 22.606-24.924 44.311-69.284-101.291-59.014-241.044 30.845-330.906 101.47-101.48 266.593-101.48 368.072 0.009 90.717 90.706 100.337 232.257 28.868 333.764z",
          "M368.774 144.836v-0.024c-0.102 0-0.18 0.014-0.296 0.014v-0.014c-0.034 0-0.088 0-0.121 0.014-0.055-0.014-0.106-0.014-0.144-0.014v0.014c-0.112 0-0.189-0.014-0.287-0.014v0.024c-66.223 1.768-106.878 39.25-106.21 104.821 1.010 94.513 40.826 151.848 106.312 150.843v0.019c0.055 0 0.116 0 0.171 0 0.033 0 0.059 0 0.116 0 0 0 0.014 0 0.043 0h0.028c0.038 0 0.079 0 0.079 0 0.078 0 0.135 0 0.189 0v-0.019c65.488 1.005 105.312-56.33 106.326-150.843 0.675-65.571-39.982-103.054-106.205-104.821z"
        ],
        attrs: [
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {}
          ]
        },
        tags: [
          "recruitment"
        ],
        grid: 0
      },
      attrs: [
        {},
        {}
      ],
      properties: {
        order: 123,
        id: 7,
        name: "recruitment",
        prevSize: 32,
        code: 59676
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 7
    },
    {
      icon: {
        paths: [
          "M1024 775.999c0-117.697-82.017-216.174-192-241.574-18.011-4.153-36.727-6.425-56.001-6.425-5.382 0-10.701 0.233-15.997 0.569-120.183 7.664-217.058 100.878-230.385 219.435-1.033 9.188-1.616 18.523-1.616 27.995 0 17.84 1.927 35.226 5.503 52.002 23.905 111.991 123.37 195.999 242.495 195.999 136.971 0 248.001-111.030 248.001-248.001zM775.999 940.004c-90.573 0-163.999-73.426-163.999-164.005 0-90.573 73.426-163.999 163.999-163.999 90.578 0 163.999 73.426 163.999 163.999 0 90.578-73.421 164.005-163.999 164.005z",
          "M807.999 664.001h-55.996v88.001h-88.001v55.996h143.997v-143.997z",
          "M183.999 0c-15.44 0-27.999 12.561-27.999 27.999v132.001c0 15.44 12.559 28 27.999 28h24.001c15.44 0 27.999-12.561 27.999-28v-132.001c0-15.439-12.559-27.999-28.001-27.999h-23.999z",
          "M623.997 0c-15.44 0-27.995 12.561-27.995 27.999v132.001c0 15.44 12.561 28 27.995 28h24.001c15.44 0 28.001-12.561 28.001-28v-132.001c0-15.439-12.561-27.999-28.001-27.999h-24.001z",
          "M64 828.001h396c-3.904-19.41-5.977-39.464-5.977-60.001 0-6.73 0.296-13.386 0.728-19.996h-334.751c-26.512 0-48.001-21.493-48.001-48.003v-384.001h688.002v148.425c5.296-0.273 10.633-0.423 15.997-0.423 19.137 0 37.831 1.855 56.001 5.255v-313.257c0-35.345-28.655-64-64-64h-52.002v68c0 37.497-30.498 68-67.999 68h-24.001c-37.495 0-67.999-30.504-67.999-68v-68h-279.999v68c0 37.497-30.504 68-68 68h-24.001c-37.496 0-68-30.504-68-68v-68h-51.998c-35.345 0-64 28.657-64 64v608.001c0 35.345 28.655 64 64 64z",
          "M225.505 499.503c35.073 0 63.504-28.432 63.504-63.505s-28.432-63.504-63.504-63.504c-35.073 0-63.504 28.432-63.504 63.504s28.432 63.505 63.504 63.505z",
          "M416.005 499.503c35.073 0 63.505-28.432 63.505-63.505s-28.432-63.504-63.505-63.504c-35.073 0-63.504 28.432-63.504 63.504s28.432 63.505 63.504 63.505z",
          "M606.492 499.503c35.072 0 63.505-28.432 63.505-63.505s-28.433-63.504-63.505-63.504c-35.072 0-63.506 28.432-63.506 63.504s28.434 63.505 63.506 63.505z",
          "M416.003 691.507c35.072 0 63.503-28.433 63.503-63.505s-28.431-63.502-63.503-63.502c-35.071 0-63.503 28.43-63.503 63.502s28.431 63.505 63.503 63.505z",
          "M225.503 691.507c35.072 0 63.503-28.433 63.503-63.505s-28.431-63.502-63.503-63.502c-35.071 0-63.503 28.43-63.503 63.502s28.431 63.505 63.503 63.505z"
        ],
        attrs: [
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {}
          ]
        },
        tags: [
          "time-tracker"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {}
      ],
      properties: {
        order: 124,
        id: 8,
        name: "time-tracker",
        prevSize: 32,
        code: 59677
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 8
    },
    {
      icon: {
        paths: [
          "M208.5 670.339c0-26.335 23.467-47.881 52.148-47.881s52.148 21.547 52.148 47.881c0 26.336-23.467 47.882-52.148 47.882s-52.148-21.547-52.148-47.882zM469.315 622.458h208.593c28.681 0 52.148 21.547 52.148 47.881s-23.467 47.882-52.148 47.882h-208.593c-28.681 0-52.148-21.547-52.148-47.882s23.467-47.881 52.148-47.881zM782.259 861.858h-625.777c-28.733 0-52.148-21.499-52.148-47.881v-287.289h730.074v287.289c0 26.383-23.415 47.881-52.148 47.881zM156.482 191.52h52.148v47.882c0 26.335 23.467 47.881 52.148 47.881s52.148-21.547 52.148-47.881v-47.882h312.889v47.882c0 26.335 23.467 47.881 52.148 47.881s52.148-21.547 52.148-47.881v-47.882h52.148c28.733 0 52.148 21.499 52.148 47.882v191.526h-730.074v-191.526c0-26.383 23.415-47.882 52.148-47.882zM782.223 95.763h-52.148v-47.881c0-26.335-23.467-47.881-52.149-47.881s-52.148 21.547-52.148 47.881v47.881h-312.888v-47.881c0-26.335-23.467-47.881-52.148-47.881s-52.149 21.547-52.149 47.881v47.881h-52.148c-86.253 0-156.444 64.449-156.444 143.645v574.577c0 79.199 70.191 143.642 156.444 143.642h625.778c86.249 0 156.444-64.444 156.444-143.642v-574.577c0-79.196-70.195-143.645-156.444-143.645z"
        ],
        width: 939,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "calendar"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 52,
        id: 9,
        name: "calendar",
        prevSize: 32,
        code: 59668
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 9
    },
    {
      icon: {
        paths: [
          "M548.572 101.285l205.275 205.926h-166.107c-21.614 0-39.168-19.507-39.168-43.52v-162.406zM863.508 272.794l-243.841-256c-10.368-10.701-25.125-16.794-40.595-16.794h-438.857c-77.348 0-140.215 57.446-140.215 128v768c0 70.554 62.866 128 140.215 128h597.285c77.352 0 140.218-57.446 140.218-128v-588.8c0-12.749-5.049-24.986-14.21-34.406z"
        ],
        width: 945,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "file"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 51,
        id: 10,
        name: "file",
        prevSize: 32,
        code: 59669
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 10
    },
    {
      icon: {
        paths: [
          "M374.712 809.984c-51.74 35.92-120.821 28.694-165.558-21.548-51.402-57.722-51.402-150.672 0-208.395l331.745-372.535c18.912-21.236 50.243-21.236 69.154 0 18.090 20.315 18.090 52.615 0 72.929l-331.745 372.534c-15.222 17.094-15.222 45.444 0 62.539 14.401 16.169 37.080 16.169 51.481 0l331.745-372.535c48.534-54.502 48.534-143.503 0-198.005-47.713-53.58-124.402-53.58-172.115 0l-331.744 372.534c-81.847 91.911-81.847 241.559 0 333.471 81.025 90.99 211.724 90.99 292.749 0l271.427-304.799c18.911-21.237 50.245-21.237 69.153 0 18.088 20.314 18.088 52.614 0 72.929l-271.427 304.801c-118.848 133.464-312.209 133.464-431.056 0-117.227-131.643-118.012-343.86-2.414-476.589l0.201-0.231 333.956-375.044c85.536-96.053 224.887-96.054 310.423-0.001 84.717 95.131 84.717 248.732 0 343.863l-353.453 396.912-2.521-2.831z"
        ],
        width: 805,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "paperclip"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 50,
        id: 11,
        name: "paperclip",
        prevSize: 32,
        code: 59670
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 11
    },
    {
      icon: {
        paths: [
          "M0 113.778h113.778v-113.778c-62.578 0-113.778 51.2-113.778 113.778zM0 568.889h113.778v-113.778h-113.778v113.778zM227.556 1024h113.778v-113.778h-113.778v113.778zM0 341.333h113.778v-113.778h-113.778v113.778zM568.889 0h-113.778v113.778h113.778v-113.778zM910.222 0v113.778h113.778c0-62.578-51.2-113.778-113.778-113.778zM113.778 1024v-113.778h-113.778c0 62.578 51.2 113.778 113.778 113.778zM0 796.444h113.778v-113.778h-113.778v113.778zM341.333 0h-113.778v113.778h113.778v-113.778zM455.111 1024h113.778v-113.778h-113.778v113.778zM910.222 568.889h113.778v-113.778h-113.778v113.778zM910.222 1024c62.578 0 113.778-51.2 113.778-113.778h-113.778v113.778zM910.222 341.333h113.778v-113.778h-113.778v113.778zM910.222 796.444h113.778v-113.778h-113.778v113.778zM682.667 1024h113.778v-113.778h-113.778v113.778zM682.667 113.778h113.778v-113.778h-113.778v113.778zM284.444 796.444h455.111c31.289 0 56.889-25.6 56.889-56.889v-455.111c0-31.289-25.6-56.889-56.889-56.889h-455.111c-31.289 0-56.889 25.6-56.889 56.889v455.111c0 31.289 25.6 56.889 56.889 56.889zM341.333 341.333h341.333v341.333h-341.333v-341.333z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "filter-all"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 8,
        id: 12,
        name: "filter-all",
        prevSize: 32,
        code: 59667
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 12
    },
    {
      icon: {
        paths: [
          "M0 512c0 282.77 225.516 512 503.703 512s503.706-229.23 503.706-512c0-282.77-225.518-512-503.706-512s-503.703 229.23-503.703 512zM3344.589 512c0 282.77 225.51 512 503.706 512s503.706-229.23 503.706-512c0-182.92-96-351.945-251.853-443.405s-347.853-91.46-503.706 0c-155.853 91.46-251.853 260.485-251.853 443.405zM2176 1024c-278.188 0-503.703-229.23-503.703-512s225.516-512 503.703-512c278.188 0 503.706 229.23 503.706 512s-225.518 512-503.706 512z"
        ],
        width: 4352,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "more"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 205,
        id: 13,
        name: "more",
        prevSize: 32,
        code: 59665
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 13
    },
    {
      icon: {
        paths: [
          "M896 575.664v-64h-128v64h128zM448 255.914h64v-128h-64v128zM512 191.914l45.241 45.268 45.298-45.27-45.299-45.269-45.24 45.27zM768 575.664c0 176.509-143.275 319.747-320 319.747v128c247.341 0 448-200.467 448-447.747h-128zM448 895.411c-176.725 0-320-143.238-320-319.747h-128c0 247.28 200.661 447.747 448 447.747v-128zM128 575.664c0-176.508 143.275-319.75 320-319.75v-128c-247.339 0-448 200.47-448 447.75h128zM338.76 109.27l128 127.914 90.479-90.54-128-127.914-90.479 90.54zM466.759 146.645l-128 127.922 90.482 90.538 128-127.922-90.482-90.538z"
        ],
        width: 896,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "rollback"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 49,
        id: 14,
        name: "rollback",
        prevSize: 32,
        code: 59666
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 14
    },
    {
      icon: {
        paths: [
          "M0 182.9c0-101.038 229.348-182.9 512.264-182.9 283.051 0 511.87 81.862 511.736 182.9 0 17.457-6.746 34.385-20.499 50.387-10.054 12.461-23.034 28.26-38.054 46.535-104.365 126.99-307.027 373.593-307.027 451.513v198.899c0 51.974-66.002 93.766-146.287 93.766s-146.286-41.92-146.286-93.766v-198.899c0-80.653-220.134-346.111-316.031-461.753-10.090-12.168-18.805-22.676-25.743-31.137h0.132c-15.74-17.457-24.205-36.236-24.205-55.544zM109.913 182.767c0 59.512 192.182 109.766 402.616 109.766s402.613-51.18 402.613-109.766c0-58.586-189.933-109.766-402.613-109.766-212.815 0-402.616 50.255-402.616 109.766z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "filter"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 47,
        id: 15,
        name: "filter",
        prevSize: 32,
        code: 59664
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 15
    },
    {
      icon: {
        paths: [
          "M512 64h-157.733v87.048c-40.348 10.508-78.186 27.212-112.025 49.68l-58.149-58.267-105.555 105.633 58.149 58.188c-22.546 34.035-39.367 72.148-49.797 112.731h-86.891v186.134h86.891c10.626 41.483 27.879 80.422 51.209 115.044l-59.639 59.64 105.594 105.515 60.541-60.502c33.447 21.763 70.501 38.152 110.103 48.268v86.889h157.301v-294.432c-84.773 0-202.667-25.546-202.667-153.568 0-131.584 117.894-149.333 202.667-149.333v-298.667z",
          "M512 0h512v1024h-512v-1024zM640 853.332h85.332v-85.332h-85.332v85.332zM640 640h85.332v-85.332h-85.332v85.332zM640 426.667h85.332v-85.334h-85.332v85.334zM640 213.333h85.332v-85.333h-85.332v85.333zM810.668 853.332h85.332v-85.332h-85.332v85.332zM810.668 640h85.332v-85.332h-85.332v85.332zM810.668 426.667h85.332v-85.334h-85.332v85.334zM810.668 213.333h85.332v-85.333h-85.332v85.333z"
        ],
        attrs: [
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {}
          ]
        },
        tags: [
          "gear"
        ],
        grid: 0
      },
      attrs: [
        {},
        {}
      ],
      properties: {
        order: 46,
        id: 16,
        name: "gear",
        prevSize: 32,
        code: 59663
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 16
    },
    {
      icon: {
        paths: [
          "M512 0c50.259 0 90.998 40.914 90.998 91.086 0 5.028-0.443 10.057-1.218 14.857 132.403 43.771 228.823 178.4 228.823 337.714v126.629c0 0 0 180.797 45.501 180.797 25.129 0 45.496 20.116 45.496 45.486 0 25.144-20.26 45.486-45.496 45.486h-728.205c-25.13 0-45.499-20.229-45.499-45.486 0-25.139 20.259-45.486 46.717-45.486 44.281-1.597 44.281-182.057 44.281-182.057v-125.255c0-159.2 103.175-293.829 228.823-337.6-0.775-4.914-1.218-9.943-1.218-15.086 0-50.286 40.849-91.086 90.998-91.086zM511.997 1024c75.83 0 136.384-61.030 136.492-136.571h-272.986c0.111 75.658 61.218 136.571 136.494 136.571z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "bell"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 31,
        id: 17,
        name: "bell",
        prevSize: 32,
        code: 59648
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 17
    },
    {
      icon: {
        paths: [
          "M965.98 156.887c-6.943-8.468-17.251-12.917-28.133-12.917h-737.032v-76.633c0-20.401-15.671-36.304-35.847-36.304h-97.37c-20.175 0.001-36.532 16.778-36.532 37.18s16.357 37.179 36.532 37.179h60.231v727.515c0 0.273 0.338 0.526 0.342 0.799-0.050 1.536 0.036 3.079 0.036 4.628 0 74.991 60.411 135.987 134.57 135.987 61.497 0 113.523-41.472 129.484-99.062h189.043c15.961 57.59 67.912 99.062 129.413 99.062 74.158 0 134.492-61.003 134.492-135.987s-60.334-135.96-134.492-135.96c-61.501 0-113.45 43.738-129.413 99.089h-189.042c-15.961-55.351-68.254-99.082-129.749-99.082-22.095 0-41.792 5.414-61.698 14.998v-73.527c5.53 1.028 11.59 2.741 17.251 2.741h585.965c46.933 0 86.808-33.591 99.219-82.734 0.191-0.752 0.355-1.802 0.498-2.566l69.994-374.054c2.028-10.809-0.819-21.882-7.762-30.353zM710.717 776.226c33.867 0 61.426 27.86 61.426 62.109s-27.559 62.116-61.426 62.116c-33.874 0-61.432-27.866-61.432-62.116s27.558-62.109 61.432-62.109zM262.854 776.226c33.871 0 61.428 27.86 61.428 62.109s-27.557 62.116-61.428 62.116c-33.873 0-61.43-27.866-61.43-62.116s27.558-62.109 61.43-62.109z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "cart"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 32,
        id: 18,
        name: "cart",
        prevSize: 32,
        code: 59649
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 18
    },
    {
      icon: {
        paths: [
          "M102.4 460.8l307.2 307.2 512-512"
        ],
        attrs: [
          {
            fill: "none",
            strokeLinejoin: "round",
            strokeLinecap: "round",
            strokeMiterlimit: "4",
            strokeWidth: 102.4
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "check"
        ],
        grid: 0
      },
      attrs: [
        {
          fill: "none",
          strokeLinejoin: "round",
          strokeLinecap: "round",
          strokeMiterlimit: "4",
          strokeWidth: 102.4
        }
      ],
      properties: {
        order: 209,
        id: 19,
        name: "check",
        prevSize: 32,
        code: 59650
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 19
    },
    {
      icon: {
        paths: [
          "M615.245 512.023l385.979 386.332c28.555 28.577 28.533 74.884-0.044 103.439-28.577 28.548-74.891 28.526-103.439-0.051l-386.013-386.357-386.904 386.327c-28.585 28.548-74.897 28.511-103.44-0.073s-28.508-74.898 0.077-103.439l386.874-386.302-386.711-387.060c-28.551-28.577-28.53-74.889 0.047-103.44s74.889-28.53 103.439 0.047l386.741 387.091 385.897-385.326c28.592-28.543 74.898-28.508 103.439 0.077 28.548 28.585 28.511 74.896-0.073 103.44l-385.869 385.295z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "close"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 34,
        id: 20,
        name: "close",
        prevSize: 32,
        code: 59651
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 20
    },
    {
      icon: {
        paths: [
          "M68.267 146.286v91.428c0 80.572 198.755 146.286 443.733 146.286 244.982 0 443.733-65.714 443.733-146.286v-91.428c0-80.572-198.752-146.286-443.733-146.286-244.978 0-443.733 65.714-443.733 146.286zM68.267 352v205.714c0 80.572 198.755 146.286 443.733 146.286 244.982 0 443.733-65.714 443.733-146.286v-205.714c-95.334 66.286-269.821 97.144-443.733 97.144s-348.398-30.858-443.733-97.144zM68.267 672v205.711c0 80.575 198.755 146.289 443.733 146.289 244.982 0 443.733-65.713 443.733-146.289v-205.711c-95.334 66.284-269.821 97.147-443.733 97.147s-348.398-30.863-443.733-97.147z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "coin"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 35,
        id: 21,
        name: "coin",
        prevSize: 32,
        code: 59652
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 21
    },
    {
      icon: {
        paths: [
          "M921.6 563.2v-153.6c0-108.633-43.151-212.816-119.972-289.631-76.814-76.815-180.995-119.969-289.628-119.969s-212.816 43.154-289.631 119.969c-76.815 76.815-119.969 180.998-119.969 289.631v153.6c-42.984 32.238-74.735 77.183-90.755 128.471-16.021 51.282-15.498 106.312 1.493 157.286 16.991 50.968 49.589 95.307 93.177 126.723s95.956 48.319 149.686 48.319h51.2c13.579 0 26.602-5.393 36.204-14.998 9.602-9.598 14.996-22.624 14.996-36.202v-409.6c0-13.579-5.394-26.602-14.996-36.204s-22.625-14.996-36.204-14.996h-51.2c-17.195-0.017-34.348 1.698-51.2 5.12v-107.52c0-81.474 32.366-159.612 89.977-217.223s135.749-89.977 217.223-89.977c81.474 0 159.612 32.366 217.225 89.977 57.61 57.611 89.975 135.749 89.975 217.223v107.52c-16.848-3.422-34.004-5.137-51.2-5.12h-51.2c-13.578 0-26.604 5.394-36.204 14.996-9.602 9.602-14.996 22.625-14.996 36.204v409.6c0 13.578 5.394 26.604 14.996 36.202 9.6 9.605 22.626 14.998 36.204 14.998h51.2c53.733 0 106.1-16.903 149.688-48.319s76.186-75.756 93.177-126.723c16.992-50.975 17.51-106.004 1.488-157.286-16.015-51.288-47.773-96.233-90.754-128.471z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "headphones"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 36,
        id: 22,
        name: "headphones",
        prevSize: 32,
        code: 59653
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 22
    },
    {
      icon: {
        paths: [
          "M288.336 974.329h-257.269v-257.27h257.269v257.27zM631.362 717.059h-257.27v257.27h257.27v-257.27zM974.391 717.059h-257.27v257.27h257.27v-257.27zM459.849 374.036h-257.27v257.27h257.27v-257.27zM802.877 374.036h-257.272v257.27h257.272v-257.27zM926.365 308.861c11.564-20.607 4.28-46.686-16.295-58.314l-385.903-214.391c-13.044-7.332-28.977-7.332-42.021 0l-385.904 214.391c-19.964 12.734-25.83 39.242-13.095 59.206 11.757 18.437 35.503 25.075 55.116 15.402l364.465-202.385 365.324 203.243c20.76 11.388 46.824 3.79 58.218-16.971 0.027-0.060 0.061-0.12 0.096-0.18z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "home"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 37,
        id: 23,
        name: "home",
        prevSize: 32,
        code: 59654
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 23
    },
    {
      icon: {
        paths: [
          "M1024 512c0 47.104-35.291 85.334-78.768 85.334h-630.156c-43.481 0-78.769-38.23-78.769-85.334s35.289-85.334 78.769-85.334h630.156c43.476 0 78.768 38.23 78.768 85.334z",
          "M1024 85.334c0 47.104-35.291 85.333-78.768 85.333h-630.156c-43.481 0-78.769-38.229-78.769-85.333s35.289-85.334 78.769-85.334h630.156c43.476 0 78.768 38.229 78.768 85.334z",
          "M1024 938.664c0 47.104-35.291 85.336-78.768 85.336h-630.156c-43.481 0-78.769-38.232-78.769-85.336s35.289-85.328 78.769-85.328h630.156c43.476 0 78.768 38.224 78.768 85.328z",
          "M0 85.334c0 47.061 35.328 85.333 78.769 85.333s78.77-38.272 78.77-85.333c0-47.062-35.328-85.334-78.77-85.334s-78.769 38.272-78.769 85.334z",
          "M0 512c0 47.062 35.328 85.334 78.769 85.334s78.77-38.272 78.77-85.334c0-47.062-35.328-85.334-78.77-85.334s-78.769 38.272-78.769 85.334z",
          "M0 938.664c0 47.067 35.328 85.336 78.769 85.336s78.77-38.268 78.77-85.336c0-47.060-35.328-85.328-78.77-85.328s-78.769 38.268-78.769 85.328z"
        ],
        attrs: [
          {},
          {},
          {},
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {},
            {},
            {},
            {}
          ]
        },
        tags: [
          "list"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {},
        {},
        {},
        {}
      ],
      properties: {
        order: 38,
        id: 24,
        name: "list",
        prevSize: 32,
        code: 59655
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 24
    },
    {
      icon: {
        paths: [
          "M108.561 78.547c-34.133 0-62.061 33.164-62.061 73.697v73.697c0 40.533 27.928 73.697 62.061 73.697h651.638c34.131 0 62.061-33.164 62.061-73.697v-73.697c0-40.533-27.93-73.697-62.061-73.697h-651.638zM108.561 760.243v73.696c0 9.658 7.385 18.426 15.515 18.426h211.41l-35.902 41.453c-14.895 18.317 8.688 42.637 21.348 26.534l62.061-73.696c5.989-6.893 5.989-19.68 0-26.534l-62.061-73.696c-12.319-14.63-35.374 9.875-21.348 26.528l35.871 42.56h-195.863v-55.27c0-24.506-31.030-23.731-31.030 0zM542.985 741.818c-34.134 0-62.061 33.165-62.061 73.696v73.702c0 40.531 27.927 73.696 62.061 73.696h372.362c34.138 0 62.061-33.165 62.061-73.696v-73.702c0-40.531-27.923-73.696-62.061-73.696h-372.362zM108.561 410.183c-34.133 0-62.061 33.164-62.061 73.697v73.697c0 40.534 27.928 73.697 62.061 73.697h651.638c34.131 0 62.061-33.164 62.061-73.697v-73.697c0-40.534-27.93-73.697-62.061-73.697h-651.638z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "listWithElem"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 39,
        id: 25,
        name: "listWithElem",
        prevSize: 32,
        code: 59656
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 25
    },
    {
      icon: {
        paths: [
          "M798.734 799.396c52.859-72.786 81.36-160.483 81.408-250.507 0.007-2.494-0.485-4.963-1.434-7.268-0.956-2.304-2.348-4.398-4.11-6.161-1.754-1.763-3.843-3.161-6.144-4.114s-4.765-1.444-7.25-1.442h-351.286l-320.452 349.828c62.533 51.057 138.416 82.985 218.575 91.962 16.047 1.754 32.177 2.642 48.319 2.656 101.461 0.212 199.552-36.482 276.072-103.253l66.301-71.7z",
          "M592.917 452.073h362.502c2.485 0.001 4.949-0.489 7.25-1.442 2.294-0.953 4.383-2.352 6.144-4.115s3.154-3.856 4.11-6.16c0.949-2.304 1.44-4.773 1.434-7.267-0.123-30.473-3.707-60.832-10.677-90.494l-21.422-66.284c-17.64-41.996-42.271-80.683-72.841-114.407l-0.020-0.038c-37.369-40.815-82.719-73.492-133.229-96-50.504-22.508-105.088-34.366-160.36-34.837h-0.131c-5.024 0-9.842 2-13.394 5.561s-5.549 8.389-5.549 13.424v365.793c0.008 9.616 3.823 18.835 10.607 25.635s15.983 10.622 25.577 10.63z",
          "M477.239 142.456c0.001-2.494-0.487-4.963-1.439-7.267s-2.346-4.398-4.106-6.16c-1.759-1.763-3.848-3.162-6.147-4.115s-4.763-1.444-7.251-1.442h-2.608c-83.474-0.122-165.128 24.453-234.725 70.644s-124.042 111.945-156.509 189.018c-32.468 77.073-41.514 162.036-26.004 244.24s54.884 157.993 113.189 217.863l325.601-355.452v-347.329z"
        ],
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "pie"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 40,
        id: 26,
        name: "pie",
        prevSize: 32,
        code: 59657
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 26
    },
    {
      icon: {
        paths: [
          "M122.093 280.931l-88.845-147.014 59.23-58.806 148.074 88.209v58.806l152.306 151.215c0 4.2 0 8.401 0 12.601l-54.999 50.405-156.536-155.415h-59.23zM756.702 637.966c-12.698 0-21.156 0-33.847 0-29.614 0-55.001-4.2-80.385-8.401l-88.845 100.813 198.844 222.618c46.537 50.408 126.921 54.607 173.459 4.205 50.77-50.408 46.537-126.013-4.233-172.223l-164.994-147.012zM900.54 478.351c67.693-67.206 88.849-168.017 63.461-256.225-4.226-16.802-25.382-21.002-33.84-8.401l-148.077 147.014-118.46-117.611 148.074-147.015c12.691-12.601 8.465-29.403-8.458-33.603-88.849-29.403-190.384-8.401-258.076 63.006-76.152 75.607-93.075 193.219-50.768 285.628l-423.071 373.834c-50.768 46.21-54.999 126.013-4.231 172.223 50.769 50.401 126.922 46.203 173.459-4.205l376.533-420.040c93.079 42.004 207.303 25.203 283.454-54.605z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "repair"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 41,
        id: 27,
        name: "repair",
        prevSize: 32,
        code: 59658
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 27
    },
    {
      icon: {
        paths: [
          "M899.604 796.317h-775.211c-32.974-0.075-64.578-13.947-87.892-38.584-23.314-24.631-36.439-58.020-36.502-92.852v-533.479c0.071-34.828 13.199-68.207 36.512-92.833s54.912-38.495 87.881-38.569h775.211c32.973 0.075 64.573 13.943 87.887 38.569s36.441 58.006 36.509 92.833v533.479c-0.061 34.832-13.189 68.221-36.502 92.852-23.313 24.637-54.914 38.509-87.893 38.584z",
          "M603.968 1012.367c-9.84 0-19.277-4.13-26.235-11.476-6.958-7.352-10.867-17.319-10.867-27.716v-216.057c0-5.147 0.96-10.24 2.824-14.998 1.864-4.751 4.597-9.073 8.042-12.711s7.535-6.526 12.037-8.499c4.502-1.966 9.326-2.983 14.198-2.983s9.697 1.017 14.198 2.983c4.502 1.973 8.591 4.861 12.037 8.499s6.177 7.96 8.042 12.711c1.864 4.758 2.824 9.851 2.824 14.998v216.057c0.003 5.147-0.953 10.247-2.817 15.005s-4.596 9.079-8.042 12.718c-3.445 3.639-7.537 6.526-12.040 8.492-4.504 1.973-9.329 2.983-14.203 2.976z",
          "M450.101 1012.367c-9.84 0-19.276-4.13-26.234-11.476-6.958-7.352-10.867-17.319-10.867-27.716v-216.057c0-10.39 3.909-20.357 10.867-27.709s16.394-11.482 26.234-11.482c9.84 0 19.277 4.13 26.235 11.482s10.867 17.319 10.867 27.709v216.057c0.004 5.147-0.953 10.247-2.816 15.005s-4.596 9.079-8.042 12.718c-3.446 3.639-7.538 6.526-12.041 8.492-4.503 1.973-9.329 2.983-14.203 2.976z",
          "M750.592 1024h-447.091c-9.84 0-19.276-4.13-26.235-11.476-6.958-7.352-10.867-17.319-10.867-27.716s3.909-20.364 10.867-27.709c6.958-7.352 16.395-11.482 26.235-11.482h447.091c9.837 0 19.272 4.13 26.235 11.482 6.956 7.345 10.861 17.312 10.861 27.709s-3.905 20.364-10.861 27.716c-6.963 7.345-16.398 11.476-26.235 11.476z"
        ],
        attrs: [
          {},
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {},
            {}
          ]
        },
        tags: [
          "screen"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {},
        {}
      ],
      properties: {
        order: 42,
        id: 28,
        name: "screen",
        prevSize: 32,
        code: 59659
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 28
    },
    {
      icon: {
        paths: [
          "M803.606 715.254l176.23 176.235c45.973 45.973-22.986 114.932-68.959 68.959l-174.124-174.129c-175.489 150.206-439.84 142.263-605.93-23.825-174.431-174.431-174.431-457.24 0-631.671s457.24-174.431 631.671 0c159.442 159.439 173.144 409.429 41.111 584.431zM693.536 199.783c-136.348-136.346-357.407-136.346-493.752 0s-136.346 357.404 0 493.752c136.346 136.343 357.404 136.343 493.752 0 136.343-136.348 136.343-357.407 0-493.752z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "search"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 43,
        id: 29,
        name: "search",
        prevSize: 32,
        code: 59660
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 29
    },
    {
      icon: {
        paths: [
          "M567.567 862.757c-24.57 42.995-86.565 42.995-111.135 0l-401.717-703.004c-24.381-42.666 6.427-95.753 55.568-95.753h803.433c49.14 0 79.949 53.087 55.567 95.753l-401.716 703.004z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "triagle-bottom"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 44,
        id: 30,
        name: "triagle-bottom",
        prevSize: 32,
        code: 59661
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 30
    },
    {
      icon: {
        paths: [
          "M682.667 341.333c0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-94.257 76.41-170.667 170.667-170.667s170.667 76.41 170.667 170.667z",
          "M512 597.333c-260.267 0-341.333 170.667-341.333 170.667v85.333h682.667v-85.333c0 0-81.067-170.667-341.333-170.667z"
        ],
        attrs: [
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {}
          ]
        },
        tags: [
          "user"
        ],
        grid: 0
      },
      attrs: [
        {},
        {}
      ],
      properties: {
        order: 45,
        id: 31,
        name: "user",
        prevSize: 32,
        code: 59662
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 31
    },
    {
      icon: {
        paths: [
          "M109.714 0h804.57c62.174 0 109.716 49.304 109.716 113.778v568.889c0 64.472-47.542 113.778-109.716 113.778h-804.57c-62.171 0-109.714-49.306-109.714-113.778v-568.889c0-64.474 47.543-113.778 109.714-113.778zM475.435 265.479c0-64.474-47.543-113.778-109.714-113.778h-182.857c-21.943 0-36.572 15.17-36.572 37.926v303.408c0 22.756 14.629 37.926 36.572 37.926h182.857c62.171 0 109.714 49.306 109.714 113.778v-379.259zM548.569 265.479v379.259c0-64.472 47.541-113.778 109.715-113.778h182.858c21.942 0 36.568-15.17 36.568-37.926v-303.408c0-22.756-14.626-37.926-36.568-37.926h-182.858c-62.174 0-109.715 49.303-109.715 113.778z",
          "M676.574 879.883c14.626 41.717 51.2 68.267 91.426 68.267 21.942 0 36.574 15.167 36.574 37.922s-14.632 37.928-36.574 37.928h-511.998c-21.943 0-36.571-15.172-36.571-37.928s14.628-37.922 36.571-37.922c40.229 0 76.8-26.55 87.772-68.267 3.657 0 3.657-3.794 3.657-7.589h325.485c3.658 0 3.658 3.794 3.658 7.589z"
        ],
        attrs: [
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {}
          ]
        },
        tags: [
          "strongbook"
        ],
        grid: 0
      },
      attrs: [
        {},
        {}
      ],
      properties: {
        order: 147,
        id: 32,
        name: "strongbook",
        prevSize: 32,
        code: 59672
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 32
    },
    {
      icon: {
        paths: [
          "M512 128c-228.844 0-433.906 150.156-510.281 373.656-2.281 6.719-2.281 13.969 0 20.688 76.375 223.497 281.437 373.656 510.281 373.656s433.91-150.159 510.28-373.656c2.28-6.719 2.28-13.969 0-20.688-76.377-223.5-281.436-373.656-510.28-373.656v0zM512 832c-197.937 0-375.843-128.157-446.063-320 70.219-191.844 248.125-320 446.063-320 197.939 0 375.842 128.156 446.061 320-70.219 191.843-248.122 320-446.061 320z",
          "M512 320c-105.875 0-192 86.125-192 192s86.125 192 192 192c105.875 0 192-86.125 192-192s-86.125-192-192-192z",
          "M945.78 894.785l-816.333-816.171c-3.361-3.314-7.342-5.932-11.715-7.708s-9.054-2.672-13.774-2.639c-9.533 0.068-18.648 3.918-25.341 10.704-3.314 3.361-5.934 7.341-7.709 11.713s-2.672 9.052-2.639 13.771c0.068 9.531 3.919 18.644 10.706 25.336l151.955 151.925 144.617 143.872 519.048 519.659c3.325 3.325 7.27 5.96 11.619 7.762 4.342 1.795 9.004 2.724 13.701 2.724 4.704 0 9.366-0.928 13.708-2.724 4.349-1.802 8.294-4.437 11.619-7.762 3.331-3.325 5.967-7.277 7.769-11.619 1.795-4.349 2.724-9.004 2.724-13.701 0-4.704-0.928-9.359-2.724-13.708-1.802-4.342-4.437-8.288-7.769-11.619l0.539 0.184z"
        ],
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "eye-crossed"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 153,
        id: 33,
        name: "eye-crossed",
        prevSize: 32,
        code: 59682
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 33
    },
    {
      icon: {
        paths: [
          "M512 128c-228.844 0-433.906 150.156-510.281 373.656-2.281 6.719-2.281 13.969 0 20.688 76.375 223.497 281.437 373.656 510.281 373.656s433.91-150.159 510.28-373.656c2.28-6.719 2.28-13.969 0-20.688-76.377-223.5-281.436-373.656-510.28-373.656v0zM512 832c-197.937 0-375.843-128.157-446.063-320 70.219-191.844 248.125-320 446.063-320 197.939 0 375.842 128.156 446.061 320-70.219 191.843-248.122 320-446.061 320z",
          "M512 320c-105.875 0-192 86.125-192 192s86.125 192 192 192c105.875 0 192-86.125 192-192s-86.125-192-192-192z"
        ],
        attrs: [
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {}
          ]
        },
        tags: [
          "eye"
        ],
        grid: 0
      },
      attrs: [
        {},
        {}
      ],
      properties: {
        order: 152,
        id: 34,
        name: "eye",
        prevSize: 32,
        code: 59680
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 34
    },
    {
      icon: {
        paths: [
          "M480.229 82.267c19.546-11.005 41.6-16.786 64.032-16.786s44.484 5.781 64.031 16.786c19.546 11.005 35.927 26.862 47.561 46.041l0.123 0.203 372.395 621.682c11.392 19.736 17.417 42.114 17.485 64.904 0.060 22.789-5.845 45.2-17.126 64.998-11.29 19.797-27.563 36.301-47.198 47.855-19.644 11.554-41.967 17.775-64.759 18.022h-745.021c-22.788-0.247-45.114-6.468-64.755-18.022s-35.915-28.058-47.2-47.855c-11.285-19.797-17.19-42.208-17.126-64.998s6.094-45.165 17.49-64.9l0.342-0.592 372.17-621.297c11.633-19.179 28.013-35.035 47.56-46.041zM544.26 150.814c-7.765 0-15.4 2.001-22.167 5.811-6.739 3.794-12.39 9.254-16.415 15.857-0.017 0.027-0.033 0.055-0.049 0.082l-371.716 620.552c-3.853 6.771-5.891 14.426-5.913 22.22-0.022 7.889 2.022 15.647 5.929 22.501s9.54 12.566 16.34 16.564c6.743 3.968 14.4 6.118 22.22 6.238h743.539c7.825-0.119 15.479-2.27 22.221-6.238 6.801-3.998 12.433-9.709 16.341-16.564s5.956-14.612 5.931-22.501c-0.026-7.793-2.057-15.447-5.914-22.217l-371.715-620.554c-0.017-0.027-0.033-0.055-0.050-0.082-4.023-6.603-9.676-12.063-16.415-15.857-6.767-3.81-14.401-5.811-22.166-5.811z",
          "M544.26 333.542c23.564 0 42.667 19.103 42.667 42.667v175.699c0 23.565-19.103 42.667-42.667 42.667s-42.667-19.102-42.667-42.667v-175.699c0-23.564 19.103-42.667 42.667-42.667z",
          "M501.594 727.608c0-23.565 19.103-42.667 42.667-42.667h0.497c23.564 0 42.667 19.102 42.667 42.667s-19.103 42.667-42.667 42.667h-0.497c-23.564 0-42.667-19.103-42.667-42.667z"
        ],
        width: 1109,
        attrs: [
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {}
          ]
        },
        tags: [
          "warning"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {}
      ],
      properties: {
        order: 154,
        id: 35,
        name: "warning",
        prevSize: 32,
        code: 59683
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 35
    },
    {
      icon: {
        paths: [
          "M435.459 78.683c0.031-42.415 34.441-76.774 76.858-76.743 42.414 0.032 76.774 34.442 76.744 76.857l-0.266 356.1 356.664 0.161c42.414 0.019 76.785 34.419 76.764 76.835-0.020 42.414-34.417 76.785-76.836 76.764l-356.705-0.159-0.266 357.135c-0.031 42.419-34.442 76.774-76.858 76.744s-76.774-34.442-76.743-76.856l0.266-357.094-357.39-0.159c-42.416-0.020-76.785-34.422-76.765-76.837s34.419-76.785 76.834-76.765l357.435 0.161 0.265-356.144z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "plus"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 2,
        id: 36,
        name: "plus",
        prevSize: 32,
        code: 59681
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 36
    },
    {
      icon: {
        paths: [
          "M563.174 460.485l382.275 0.173c28.278 0.013 51.19 22.946 51.174 51.223-0.010 28.279-22.943 51.191-51.22 51.176l-382.305-0.174-0.282 382.735c-0.020 28.273-22.963 51.18-51.239 51.159-28.277-0.020-51.183-22.958-51.162-51.236l0.285-382.705-382.998-0.169c-28.277-0.015-51.19-22.948-51.177-51.226 0.013-28.277 22.946-51.19 51.223-51.177l383.027 0.174 0.284-381.737c0.021-28.277 22.961-51.183 51.238-51.162 28.278 0.021 51.185 22.961 51.164 51.238l-0.287 381.707z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "plus-thin"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 3,
        id: 37,
        name: "plus-thin",
        prevSize: 32,
        code: 59684
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 37
    },
    {
      icon: {
        paths: [
          "M1020.211 18.785l-7.913 2.683c1.266 0.691 2.225 0.292 3.249 0.133l3.984-2.178c0.205-0.239 0.512-0.412 0.68-0.637zM419.804 1020.081c0 9.812-9.289-2.113 0 0v0zM18.611 564.719c-6.962 4.211 0-7.702 0 0v0zM1020.211 18.785l1.368-0.478c-0.54-0.332-0.27-0.438-0.577-0.704-0.251 0.438-0.41 0.637-0.791 1.182zM1015.547 21.601l-996.936 543.118c0 0 143.136 68.636 294.623 122.383l608.055-577.715-501.485 637.478v273.215l127.002-239.070 374.498 148.002 100.276-910.705-2.048 1.116c-1.005 1.222-2.318 1.899-3.984 2.178zM1021.002 17.603c0.856-1.514 1.192-2.364 0.577 0.704 7.131-3.227-4.105-3.891-0.577-0.704z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "plane"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 4,
        id: 38,
        name: "plane",
        prevSize: 32,
        code: 59685
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 38
    },
    {
      icon: {
        paths: [
          "M206.013 512l366.327 366.327c33.324 33.323 33.324 87.356 0 120.678s-87.355 33.323-120.68 0l-426.666-426.666c-33.325-33.325-33.325-87.355 0-120.68l426.666-426.666c33.325-33.325 87.355-33.325 120.68 0s33.324 87.355 0 120.68l-366.327 366.327z"
        ],
        width: 597,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "left-arrow"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 6,
        id: 39,
        name: "left-arrow",
        prevSize: 32,
        code: 59686
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 39
    },
    {
      icon: {
        paths: [
          "M391.321 512l-366.327-366.327c-33.325-33.325-33.325-87.355 0-120.68s87.355-33.325 120.68 0l426.667 426.666c33.324 33.325 33.324 87.355 0 120.68l-426.667 426.666c-33.325 33.323-87.355 33.323-120.68 0s-33.325-87.356 0-120.678l366.327-366.327z"
        ],
        width: 597,
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "right-arrow"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 5,
        id: 40,
        name: "right-arrow",
        prevSize: 32,
        code: 59687
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 40
    },
    {
      icon: {
        paths: [
          "M885.784 196.572v-28.726c0-5.287-1.039-10.522-3.062-15.407s-4.988-9.323-8.728-13.061c-3.74-3.739-8.177-6.704-13.063-8.727-4.881-2.023-10.118-3.065-15.404-3.065h-430.933c-5.287 0-10.522 1.042-15.407 3.065s-9.323 4.989-13.061 8.727c-3.739 3.738-6.704 8.176-8.727 13.061s-3.065 10.12-3.065 15.407v28.726l511.451 0z",
          "M374.333 249.897v169.823c0 5.287 1.041 10.522 3.065 15.407s4.988 9.323 8.727 13.061c3.739 3.739 8.177 6.704 13.061 8.727s10.12 3.065 15.407 3.065h430.933c10.679 0 20.919-4.242 28.467-11.792s11.791-17.79 11.791-28.468v-169.823h-511.451zM847.721 408.297c0 1.8-0.356 3.583-1.044 5.245s-1.697 3.173-2.97 4.446c-1.273 1.273-2.784 2.283-4.447 2.971s-3.447 1.044-5.247 1.044h-109.934c-1.799 0-3.584-0.354-5.247-1.044s-3.17-1.698-4.442-2.971c-1.273-1.273-2.282-2.783-2.974-4.446-0.688-1.663-1.044-3.445-1.044-5.245v-32.129c0-1.8 0.356-3.583 1.044-5.245 0.692-1.663 1.702-3.173 2.974-4.446s2.779-2.283 4.442-2.971c1.663-0.689 3.447-1.044 5.247-1.043h109.934c1.799 0 3.584 0.354 5.247 1.043s3.174 1.698 4.447 2.971c1.273 1.273 2.282 2.783 2.97 4.446s1.044 3.445 1.044 5.245v32.129z",
          "M977.979 648.343c-116.19 75.878-381.372 225.529-381.372 225.529-0.2 0.102-0.395 0.215-0.585 0.336-39.956 23.815-81.871 25.81-123.805 18.364-4.325-0.77-268.675-33.109-307.824-37.878l-1.083-24.366v-291.977c20.949-1.921 60.513-3.53 64.903-3.808 112.745-7.28 221.434 18.671 331.233 40.258 11.24 2.214 21.358 8.265 28.628 17.111 7.27 8.85 11.244 19.948 11.244 31.398 0.005 1.96-0.117 3.92-0.361 5.866-1.429 12.005-7.212 23.074-16.257 31.105-9.040 8.026-20.719 12.464-32.812 12.459h-196.678c-4.141-0.122-8.16 1.404-11.177 4.242s-4.782 6.758-4.91 10.898c0.030 2.555 0.711 5.061 1.981 7.275 1.269 2.219 3.083 4.076 5.271 5.393 2.205 1.775 4.949 2.745 7.779 2.75h173.563c5.335-0.361 36.094-0.97 57.207-2.111 9.728-0.536 19.368-2.18 28.726-4.886l26.341-7.617 295.531-124.050c10.947-4.593 23.22-4.925 34.402-0.936s20.465 12.015 26.034 22.499c5.569 10.489 7.017 22.674 4.057 34.172-2.955 11.498-10.103 21.475-20.036 27.975v0z",
          "M131.047 504.291h-106.57v350.618h106.57v-350.618z"
        ],
        attrs: [
          {},
          {},
          {},
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {},
            {},
            {},
            {}
          ]
        },
        tags: [
          "ppList"
        ],
        grid: 0
      },
      attrs: [
        {},
        {},
        {},
        {}
      ],
      properties: {
        order: 155,
        id: 41,
        name: "ppList",
        prevSize: 32,
        code: 59688
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 41
    },
    {
      icon: {
        paths: [
          "M281.019 799.094c-83.973-67.553-137.709-171.131-137.709-287.301 0-171.72 117.587-315.585 276.516-356.604v-94.993c-210.358 42.69-368.688 228.659-368.688 451.598 0 137.772 60.49 261.307 156.285 345.741 74.148 69.064 120.231-23.107 73.596-58.44zM812.692 162.724c-47.212-42.644-116.342 26.487-71.025 60.734 84.751 67.533 139.034 171.608 139.034 288.334 0 171.748-117.612 315.635-276.526 356.631v95.012c210.36-42.737 368.691-228.68 368.691-451.649 0-139.584-62.111-264.564-160.174-349.062zM460.55 234.801l150.010-89.831c21.827-13.073 21.873-34.365 0.118-47.53l-151.397-91.633c-21.779-13.145-39.356-3.222-39.25 22.233l0.815 184.352c0.066 25.442 17.853 35.483 39.705 22.41zM564.746 789.284l-151.417 91.633c-21.772 13.164-21.726 34.452 0.125 47.529l149.997 89.841c21.827 13.046 39.654 3.036 39.767-22.436l0.788-184.346c0.077-25.436-17.526-35.364-39.26-22.221z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: [
            {}
          ]
        },
        tags: [
          "exchange"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 156,
        id: 42,
        name: "exchange",
        prevSize: 32,
        code: 59693
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 42
    },
    {
      icon: {
        paths: [
          "M928 1024h-832c-17.664 0-32-14.304-32-32v-512c0-17.696 14.336-32 32-32h96v-128c0-176.736 143.264-320 320-320s320 143.264 320 320v128h96c17.696 0 32 14.304 32 32v512c0 17.696-14.304 32-32 32zM704 304c0-97.216-85.984-176-192-176s-192 78.784-192 176v144h384v-144z"
        ],
        attrs: [],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          11912815112552552000: []
        },
        tags: [
          "locked"
        ],
        defaultCode: 59670,
        grid: 0
      },
      attrs: [],
      properties: {
        id: 43,
        order: 149,
        ligatures: "",
        prevSize: 32,
        code: 59679,
        name: "locked"
      },
      setIdx: 1,
      setId: 6,
      iconIdx: 43
    },
    {
      icon: {
        paths: [
          "M672 832v64.082c0 35.408-28.617 63.918-63.918 63.918h-480.165c-35.408 0-63.918-28.759-63.918-64.235v-735.531c0-35.488 28.776-64.235 64.273-64.235h319.727v192.061c0 35.565 28.739 63.939 64.189 63.939h159.811v64h-287.781c-53.14 0-96.219 42.952-96.219 95.961v224.078c0 52.998 42.752 95.961 96.219 95.961h287.781zM480 96v191.906c0 17.725 14.431 32.094 31.705 32.094h160.295l-192-224zM383.826 448h544.348c34.951 0 63.826 28.539 63.826 63.745v224.511c0 34.939-28.576 63.745-63.826 63.745h-544.348c-34.951 0-63.826-28.539-63.826-63.745v-224.511c0-34.939 28.576-63.745 63.826-63.745zM800 608v-64h128v-32h-160v224h32v-96h96v-32h-96zM384 576v160h32v-96h63.844c35.432 0 64.156-28.407 64.156-64 0-35.346-28.605-64-64.156-64h-95.844v64zM416 544v64h64.033c17.655 0 31.967-14.204 31.967-32 0-17.673-14.165-32-31.967-32h-64.033zM576 512v224h95.844c35.432 0 64.156-28.37 64.156-64.189v-95.621c0-35.451-28.605-64.189-64.156-64.189h-95.844zM608 544v160h64.033c17.655 0 31.967-14.199 31.967-31.994v-96.012c0-17.67-14.165-31.994-31.967-31.994h-64.033z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "document-file-pdf"
        ],
        grid: 32
      },
      attrs: [
        {}
      ],
      properties: {
        order: 1,
        id: 0,
        prevSize: 32,
        code: 59690,
        name: "document-file-pdf"
      },
      setIdx: 2,
      setId: 5,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M406 278v128h-128v-128h128zM470 214h-256v256h256v-256zM406 618v128h-128v-128h128zM470 554h-256v256h256v-256zM746 278v128h-128v-128h128zM810 214h-256v256h256v-256zM554 554h64v64h-64v-64zM618 618h64v64h-64v-64zM682 554h64v64h-64v-64zM554 682h64v64h-64v-64zM618 746h64v64h-64v-64zM682 682h64v64h-64v-64zM746 618h64v64h-64v-64zM746 746h64v64h-64v-64zM938 298h-84v-128h-128v-84h212v212zM938 938v-212h-84v128h-128v84h212zM86 938h212v-84h-128v-128h-84v212zM86 86v212h84v-128h128v-84h-212z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "qr_code_scanner"
        ],
        grid: 24
      },
      attrs: [
        {}
      ],
      properties: {
        order: 1,
        id: 0,
        name: "qr_code_scanner",
        prevSize: 24,
        code: 59703
      },
      setIdx: 0,
      setId: 6,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M426 726l342-342-60-60-282 280-110-110-60 60zM512 42l384 172v256q0 178-110 325t-274 187q-164-40-274-187t-110-325v-256z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "verified_user"
        ],
        grid: 24
      },
      attrs: [
        {}
      ],
      properties: {
        order: 1,
        id: 0,
        prevSize: 24,
        code: 59692,
        name: "verified_user"
      },
      setIdx: 3,
      setId: 4,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "email",
          "mail",
          "markunread",
          "local_post_office"
        ],
        grid: 24
      },
      attrs: [
        {}
      ],
      properties: {
        order: 1,
        id: 1,
        prevSize: 24,
        code: 59691,
        name: "email"
      },
      setIdx: 3,
      setId: 4,
      iconIdx: 1
    },
    {
      icon: {
        paths: [
          "M598 512h234l-234-234v234zM640 214l256 256v426q0 34-26 60t-60 26h-470q-34 0-59-26t-25-60v-598q0-34 26-59t60-25h298zM682 42v86h-512v598h-84v-598q0-34 25-60t59-26h512z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "file-copy"
        ],
        grid: 24
      },
      attrs: [
        {}
      ],
      properties: {
        order: 1,
        id: 2,
        prevSize: 24,
        code: 59694,
        name: "file-copy"
      },
      setIdx: 3,
      setId: 4,
      iconIdx: 2
    },
    {
      icon: {
        paths: [
          "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
        ],
        attrs: [],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "pencil",
          "write",
          "edit"
        ],
        defaultCode: 59653,
        grid: 16
      },
      attrs: [],
      properties: {
        ligatures: "pencil, write",
        name: "pencil",
        order: 55,
        id: 0,
        prevSize: 32,
        code: 59689
      },
      setIdx: 4,
      setId: 3,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M640 64c247.424 0 448 200.576 448 448s-200.576 448-448 448v-96c94.024 0 182.418-36.614 248.902-103.098s103.098-154.878 103.098-248.902c0-94.022-36.614-182.418-103.098-248.902s-154.878-103.098-248.902-103.098c-94.022 0-182.418 36.614-248.902 103.098-51.14 51.138-84.582 115.246-97.306 184.902h186.208l-224 256-224-256h164.57c31.060-217.102 217.738-384 443.43-384zM832 448v128h-256v-320h128v192z"
        ],
        width: 1088,
        attrs: [],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "history",
          "time",
          "archive",
          "past"
        ],
        defaultCode: 59725,
        grid: 16
      },
      attrs: [],
      properties: {
        ligatures: "history, time",
        name: "history",
        order: 53,
        id: 1,
        prevSize: 32,
        code: 59725
      },
      setIdx: 4,
      setId: 3,
      iconIdx: 1
    },
    {
      icon: {
        paths: [
          "M511.508 719.233l443.847-501.185c14.56-16.441 39.463-17.76 55.623-2.947 16.156 14.813 17.456 40.149 2.897 56.59l-473.138 534.26c-15.655 17.677-42.914 17.662-58.549-0.033l-472.091-534.26c-14.542-16.457-13.218-41.792 2.958-56.587s41.078-13.448 55.62 3.010l442.835 501.152z"
        ],
        attrs: [
          {}
        ],
        isMulticolor: false,
        isMulticolor2: false,
        colorPermutations: {
          1191281611121116246125525525516868681: [
            {}
          ]
        },
        tags: [
          "chevron-down"
        ],
        grid: 0
      },
      attrs: [
        {}
      ],
      properties: {
        order: 157,
        id: 8,
        name: "chevron-down",
        prevSize: 32,
        code: 59650
      },
      setIdx: 29,
      setId: 28,
      iconIdx: 8
    },
    {
      icon: {
        paths: [
          "M621.254 877.254l320-320c24.994-24.992 24.994-65.516 0-90.51l-320-320c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.516 0 90.51l210.746 210.746h-613.49c-35.346 0-64 28.654-64 64s28.654 64 64 64h613.49l-210.746 210.746c-12.496 12.496-18.744 28.876-18.744 45.254s6.248 32.758 18.744 45.254c24.994 24.994 65.516 24.994 90.51 0z"
        ],
        attrs: [],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "arrow-right",
          "right",
          "next"
        ],
        defaultCode: 59964,
        grid: 16
      },
      attrs: [],
      properties: {
        ligatures: "arrow-right2, right4",
        name: "arrow-right2",
        order: 54,
        id: 2,
        prevSize: 32,
        code: 59964
      },
      setIdx: 4,
      setId: 3,
      iconIdx: 2
    },
    {
      icon: {
        paths: [
          "M576 256l-128-128h-448v832h1024v-704h-448zM512 864l-224-224h160v-256h128v256h160l-224 224z"
        ],
        attrs: [],
        isMulticolor: false,
        isMulticolor2: false,
        tags: [
          "folder-download",
          "directory",
          "folder-save"
        ],
        defaultCode: 59699,
        grid: 16
      },
      attrs: [],
      properties: {
        ligatures: "folder-download, directory5",
        name: "folder-download",
        order: 2,
        id: 3,
        prevSize: 32,
        code: 59699
      },
      setIdx: 4,
      setId: 3,
      iconIdx: 3
    }
  ],
  height: 1024,
  metadata: {
    name: "icomoon"
  },
  preferences: {
    showGlyphs: true,
    showQuickUse: true,
    showQuickUse2: true,
    showSVGs: true,
    fontPref: {
      prefix: "icon-",
      metadata: {
        fontFamily: "icomoon"
      },
      metrics: {
        emSize: 1024,
        baseline: 6.25,
        whitespace: 50
      },
      embed: false
    },
    imagePref: {
      prefix: "icon-",
      png: true,
      useClassSelector: true,
      color: 0,
      bgColor: 16777215,
      classSelector: ".icon"
    },
    historySize: 50,
    showCodes: true,
    gridSize: 16
  }
}
